/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import Label from 'components/Form/Label';
import Colors from 'constants/Colors';

import './styles.css';
import { ValidationErrorField, ValidationErrorText } from './styles';

export default function TextEditorBox(props) {
  const editorRef = useRef(null);

  const [meta, setMeta] = useState({});

  const handleChange = () => {
    if (editorRef.current && props.onChange) {
      props.onChange(editorRef.current.getContent());
    }
  };

 

  useEffect(() => {
    var touchedList;
    var touchedItem;
    var errorList;
    var errorItem;
    
    const metaFields = props.field?.name.split('.');
    if (metaFields && metaFields.length == 3) {
      touchedList = props.form.touched[metaFields[0]]
      if (touchedList) {
        touchedItem = touchedList[parseInt(metaFields[1])]
      }
      errorList = props.form.errors[metaFields[0]]
      if (errorList) {
        errorItem = errorList[parseInt(metaFields[1])]
      }

      const metas = {
        touched: metaFields.length == 3 && touchedItem ? touchedItem[metaFields[2]] || props.form?.touched[props.field?.name] : props.form?.touched[props.field?.name],
        error: metaFields.length == 3 && errorItem ? errorItem[metaFields[2]] || props.form?.errors[props.field?.name] : props.form.errors[props.fiel?.name]
      };
      setMeta(metas)
    }

  }, [props]);

  return (
    <div style={{ marginBottom: 10, width: props.width && props.width }}>
      <Label>{ props.label ? props.isRequired ? "* " + props.label : "" : ''}</Label>
      <ValidationErrorField style={{ minHeight: props.height || 196, background: 'rgba(55,55,55,0.05)', borderRadius: 6 }} meta={meta} height={props.height}>
        <Editor
          apiKey={process.env.REACT_APP_TINYMCE_TOKEN}
          onInit={(evt, editor) => {
            editorRef.current = editor
          }}
          value={props.value}
          // initialValue={props.initialValue || props.value}
          onEditorChange={handleChange}
          disabled={props.disabled}
          init={{
            content_style: "body {font-size: 14pt;}",
            inline_styles: true,
            height: props.height,
            menubar: false,
            branding: false,
            relative_urls: false,
            remove_script_host: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
            ],
            toolbar: !props?.disableFullScreen ? 'undo redo | bold italic underline strikethrough | fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat table| fullscreen ' :
            'undo redo | bold italic underline strikethrough | fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat table|',
          }}
        />
      </ValidationErrorField>
      {
        props.error || (meta.error && meta.touched)
          ? (<ValidationErrorText>{props.error || meta.error}</ValidationErrorText>)
          : null
      }
    </div>
  );
}
